import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import LoadListList from '../LoadList/LoadListList';
import LoadListMap from '../LoadList/LoadListMap';
import LoadListMode from '../LoadList/LoadListMode';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function DashboardProject( props ) {
    //console.debug("RTS Break DashbaordProject");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [mode, setMode] = useState(0);
    const [data, setData] = useState([]);
    const [projects, setProjects] = useState([]);
    const [hasError, setHasError] = useState(false);

    const fetchData = useCallback((pFilter) => {
        let apiURL = apiRoot + "/LoadList/GetLoadList";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
                if(response.data.length === 0)
                {
                    setMode(-1);
                }
                setIsLoading(false);
                setHasError(false);
            }
            else{
                setMode(-1);
            }
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]);


    const fetchProjects = useCallback((pFilter) => {
        let apiURL = apiRoot + "/Projects/GetProjectsByManager";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                if(response.data.length === 0){
                    setMode(-1);
                    setIsLoading(false);
                    setHasError(false);
                }
                else{
                    setProjects(response.data);
                    //fetchData();
                }
            }
            else{
                setIsLoading(false);
                setHasError(false);
                setMode(-1);
            }
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]);


    useEffect(() => {
        let apiObj = {
            Customer:sessionCustomer.customer, 
            User:user, 
            SortBy:0
        }

        fetchProjects(apiObj);
    }, [sessionCustomer, user, fetchProjects]);


    useEffect(() => {
        if(projects.length > 0){
            let apiObj = {
                "user":user, 
                "status":[1,25,50,75,100],
                "customer":sessionCustomer.customer,
                "orders":[], 
                "projects":projects, 
                "products":[], 
                "reelTypes":[],
                "reels":[],
                "lenghtOperator":">=",
                "Length":0,
                "namedLocations":[],
                "crews": [],
                "trackers":[],
                "shipDateOperator":">=",
                "shipDate":null,
                "pinned":-1,
                "locked":-1,
                "daysStationaryOperator":">=",
                "daysStationary":0, 
                "sortBy":0
            }
    
            fetchData(apiObj);
        }
    }, [projects, sessionCustomer, fetchData, user]);    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Box id="pageBox">
            <Box id="modeBox">
                <LoadListMode data={data} mode={mode} modeFx={setMode} reelCount={data===null?0:data.length} locksIcon={false} pinsIcon={false} />            
            </Box>            
            <Box id="contentBox">
                {mode===-1?<Box justifyContent={"center"} alignItems={"center"} display={"flex"}><Typography variant='h4'>No Records Found</Typography></Box>:""}
                {mode===0?<LoadListList data={data} user={user} />:""}
                {mode===1?<LoadListMap data={data} user={user} />:""}
            </Box> 
        </Box>
    );
}

